import React, { useState, useEffect } from 'react'
import { Text } from 'shared/components'
import * as styles from './styles'

const NOTIFICATION_STORAGE_KEY = 'inwinNotification'
const NOTIFICATION_MAX_AGE_MS = 10000
const TOP_NOTIFICATION_HIDE_DELAY_MS = 5000

const parseNotification = () => {
	const notification = localStorage.getItem(NOTIFICATION_STORAGE_KEY)

	if (!notification) {
		return null
	}

	return JSON.parse(notification)
}

const isRecentNotification = (timestamp) =>
	Date.now() - timestamp < NOTIFICATION_MAX_AGE_MS

const InWinNotificationComponent = () => {
	const [showSuccess, setShowSuccess] = useState(false)
	const [showError, setShowError] = useState(false)
	const [errorMessage, setErrorMessage] = useState('')
	const [successMessage, setSuccessMessage] = useState('')
	const [showTopSuccess, setShowTopSuccess] = useState(false)
	const [showTopError, setShowTopError] = useState(false)

	const hideTopSuccess = () => setShowTopSuccess(false)
	const hideTopError = () => setShowTopError(false)

	const scheduleTopNotificationHide = (hideNotification) => {
		setTimeout(hideNotification, TOP_NOTIFICATION_HIDE_DELAY_MS)
	}

	const showSuccessNotification = ({ message, topOnly }) => {
		setSuccessMessage(message)

		if (!topOnly) {
			setShowSuccess(true)
		}

		setShowTopSuccess(true)
		scheduleTopNotificationHide(hideTopSuccess)
	}

	const showErrorNotification = ({ message, topOnly }) => {
		setErrorMessage(message)

		if (!topOnly) {
			setShowError(true)
		}

		setShowTopError(true)
		scheduleTopNotificationHide(hideTopError)
	}

	const checkForNotifications = () => {
		try {
			const notificationData = parseNotification()

			if (!notificationData) {
				return
			}

			const { type, message, timestamp, topOnly } = notificationData

			if (isRecentNotification(timestamp)) {
				if (type === 'success') {
					showSuccessNotification({ message, topOnly })
				} else if (type === 'error') {
					showErrorNotification({ message, topOnly })
				}
			}

			localStorage.removeItem(NOTIFICATION_STORAGE_KEY)
		} catch (error) {
			console.error('Failed to parse notification:', error)
			localStorage.removeItem(NOTIFICATION_STORAGE_KEY)
		}
	}

	useEffect(() => {
		// Check for notifications on mount
		checkForNotifications()

		// Set up polling to check for new notifications every 500ms
		const interval = setInterval(checkForNotifications, 500)

		// Cleanup interval on unmount
		return () => clearInterval(interval)
	}, [])

	return (
		<>
			{/* Success Modal */}
			{showSuccess && (
				<div css={styles.confirmationOverlay}>
					<div css={styles.successModal}>
						<div css={styles.successHeader}>
							<Text size={16} bold css={styles.successTitle}>InWin Placed!</Text>
						</div>

						<div css={styles.successContent}>
							<Text size={12} css={styles.successMessage}>
								You have successfully placed your InWin
							</Text>
						</div>

						<div css={styles.successActions}>
							<button
								css={styles.successButton}
								onClick={() => {
									setShowSuccess(false)
									setShowTopSuccess(false)
								}}
							>
								<Text size={12} bold css={styles.successButtonText}>
									Got it
								</Text>
							</button>
						</div>
					</div>
				</div>
			)}

			{/* Error Modal */}
			{showError && (
				<div css={styles.confirmationOverlay}>
					<div css={styles.errorModal}>
						<div css={styles.errorHeader}>
							<Text size={16} bold css={styles.errorTitle}>InWin was not placed.</Text>
						</div>

						<div css={styles.errorContent}>
							<Text size={12} css={styles.errorMessage}>
								{errorMessage}
							</Text>
						</div>

						<div css={styles.errorActions}>
							<button
								css={styles.errorButton}
								onClick={() => {
									setShowError(false)
									setShowTopError(false)
								}}
							>
								<Text size={12} bold css={styles.errorButtonText}>
									Got it
								</Text>
							</button>
						</div>
					</div>
				</div>
			)}

			{/* Top Error Message */}
			{showTopError && (
				<div css={styles.topErrorMessage}>
					<div css={styles.topErrorContent}>
						<div css={styles.topErrorIcon}>✕</div>
						<Text size={12} css={styles.topErrorText}>{errorMessage}</Text>
					</div>
				</div>
			)}

			{/* Top Success Message */}
			{showTopSuccess && (
				<div css={styles.topSuccessMessage}>
					<div css={styles.topSuccessContent}>
						<div css={styles.topSuccessIcon}>✓</div>
						<Text size={12} css={styles.topSuccessText}>{successMessage}</Text>
					</div>
				</div>
			)}
		</>
	)
}

export default InWinNotificationComponent
